<form (ngSubmit)="submit(form)" [formGroup]="form" autocomplete="off" fxLayout="column" fxLayoutAlign="start">
	<h1 mat-dialog-title>{{'resetPasswordModal.title' | translate}}</h1>
	<mat-dialog-content>
		<div fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
			<p>{{'resetPasswordModal.instructions' | translate}}</p>
			<mat-form-field fxFlex>
				<mat-label>{{'resetPasswordModal.emailLabel' | translate}}</mat-label>
				<input autocomplete="off" formControlName="emailAddress" matInput required>
				<mat-error>Please enter a valid email address</mat-error>
			</mat-form-field>
		</div>
	</mat-dialog-content>
	<mat-dialog-actions fxLayout="row" fxLayoutAlign="end" fxLayoutGap="5px">
		<button [color]="'accent'" mat-dialog-close mat-raised-button type="reset">
			<span>{{'resetPasswordModal.cancelButton' | translate}}</span>
		</button>
		<button [color]="'primary'" mat-raised-button type="submit">
			{{'resetPasswordModal.submitButton' | translate}}
		</button>
	</mat-dialog-actions>
</form>
